import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import colors from '../../../styles/colors';
import BaseModal, { ModalList } from '../../modals/BaseModal';
import Loader from '../../Loader';
import Icon, { Icons } from '../../Icon';
import { AppContext } from '../../../context/AppContext';
import { NoContent } from '../CustomerTable';

const ListWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 60vh;
`;

const ListContainer = styled.ul`
  width: 100%;
  position: relative;
  height: auto;
  max-height: 80vh;
  overflow: auto;
  display: grid;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: 0;
  grid-template-columns: 1fr;
`;

const ListHeader = styled.div`
  display: flex;
  position: sticky;
  top: 0;
  flex-direction: column;
  height: auto;
  border: 1px solid ${colors.grey6};
  background: ${colors.white};
  z-index: 15;
`;

const ListHeaderInner = styled.div`
  font-weight: 450;
  font-size: 1.2rem !important;
  padding: 7px 35px;
  color: #333333;
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: auto;
  min-height: 50px;
  text-align: start;
  border: 1px solid ${colors.grey6};
  background: ${colors.white};
  @media screen and (max-width:280px){
    padding: 7px;
  }
`;

const ListHeaderItem = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  /* &:first-child {
    margin-left: 10px;
  } */
`;

const ListItem = styled.li`
  cursor: pointer;
  font-size: 1.2rem !important;
  padding: 7px 35px 7px 5px;
  color: #333333;
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: auto;
  min-height: 50px;
  font-size: 17px;
  position: relative;
  text-align: start;
  border: 1px solid ${colors.grey6};
  flex-basis: 100px;
  &:first-child {
    padding: 7px 35px;
  }
`;

const PhoneContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IconContainer = styled.div`
  padding: 10px 15px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  border-radius: 5px;
`;
const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  height: 95%;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
`;

const TableHeaderCompnent = ({ ordering, ...props }) => {
  const { fieldName, order } = ordering;
  let orderingIcon = (
    <Icon
      icon={Icons.Sort}
      size={12}
      margin="5px"
      active
      activeColor={colors.grey3}
    />
  );

  if (fieldName === props.columnName && order === 'asc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortUp}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  } else if (fieldName === props.columnName && order === 'desc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortDown}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  }

  return (
    <ListHeaderItem onClick={() => props.handleSort(props.columnName)}>
      {props.children} {orderingIcon}
    </ListHeaderItem>
  );
};

export default function ContactsList({
  contacts,
  fetchMore,
  ordering,
  handleSort,
  isMore,
  loadMoreData,
  fetching,
  setFetching,
  searchQuery,
  setSearchQuery,
  getRefferedContactsClick,
  scrollToTop,
}) {
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const { app } = useContext(AppContext);
  const [contactData, setContactData] = useState({});
  const scrollContainer = React.useRef();

  const handleScroll = () => {
    if (!fetchMore) return;
    if (scrollContainer?.current.scrollTop > 0) {
      const scrollPosition = scrollContainer?.current.offsetHeight
        + scrollContainer?.current.scrollTop;
      const scrollPositionMax = scrollContainer?.current.scrollHeight - 300;
      if (scrollPosition >= scrollPositionMax && !fetching && isMore) {
        setFetching(true);

        setTimeout(() => {
          loadMoreData();
          setFetching(false);
        }, 0);
      }
    }
  };

  const history = useHistory();

  const listItemClick = (contactData) => {
    setContactData(contactData);
    setDetailsModalVisible(true);
  };

  const onDetailClick = (e, phoneNumber) => {
    e.stopPropagation();
    history.push(`/customers/${phoneNumber}`);
  };

  useEffect(() => {
    if (scrollContainer?.current) {
      scrollContainer.current.scrollTop = 0;
    }
  }, [scrollToTop]);

  return (
    <ListWrapper>
      <BaseModal
        open={detailsModalVisible}
        modalType={ModalList.ContactDetailsModal}
        onClose={setDetailsModalVisible}
        contactData={contactData}
        getRefferedContactsClick={getRefferedContactsClick}
        fetching={fetching}
        setFetching={setFetching}
      />
      {fetching && (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      )}

      {(contacts && contacts.length > 0) || fetching ? (
        <ListContainer ref={scrollContainer} onScroll={handleScroll}>
          <ListHeader>
            {(app?.searchQuery?.phoneNumber || app?.refSearchNumber)
              && contacts.length > 0 && (
                <NoContent
                  contacts={contacts}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  height="fit-content"
                  direction="row"
                  textWidth="50%"
                />
            )}
            <ListHeaderInner>
              <TableHeaderCompnent
                ordering={ordering}
                handleSort={handleSort}
                columnName="phoneNumber"
              >
                Phone Number
              </TableHeaderCompnent>
              <TableHeaderCompnent
                ordering={ordering}
                handleSort={handleSort}
                columnName="createdAt"
              >
                Created At
              </TableHeaderCompnent>
            </ListHeaderInner>
          </ListHeader>
          {contacts.map((contact) => {
            return (
              <ListItem
                key={contact._id}
                onClick={() => listItemClick(contact)}
              >
                <PhoneContainer>
                  <IconContainer
                    onClick={(e) => onDetailClick(e, contact.phoneNumber)}
                  >
                    <Icon icon={Icons.Binoculars} size={12} margin="0" />
                  </IconContainer>

                  <div>{contact.phoneNumber}</div>
                </PhoneContainer>
                <div>{moment(contact.createdAt * 1000).format('L')}</div>
              </ListItem>
            );
          })}
        </ListContainer>
      ) : (
        <>
          <NoContent contacts={contacts} />
        </>
      )}
    </ListWrapper>
  );
}
